module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"userGroupsManagement":"User Group Management","addUserGroup":"Add User Group","userGroup":"User Group","actions":"Actions","confirmDelete":"Confirm Delete","promptDelete":"Would you like to delete the user group?","successMessage":"User Group Added Successfully","deleteMessage":"User Group Deleted Successfully","updateMessage":"User Group Saved Successfully"}}')
  delete Component.options._Ctor
}
